import { OptionButtonProps } from "./types";
import { StyledButton } from "./styles";
import { MapButtonGroupStyle } from "@repo/core/components/core/ButtonGroup/utils";
import { Text } from "@repo/core/components/core/Text";

export const OptionButton = ({
  text,
  isActive,
  type,
  ...buttonProps
}: OptionButtonProps) => {
  const buttonStyle = type
    ? MapButtonGroupStyle[type]
    : MapButtonGroupStyle.dark;

  const backgroundColor = isActive
    ? buttonStyle.backgroundColorActive
    : buttonStyle.backgroundColorInactive;

  const fontColor = isActive
    ? buttonStyle.fontColorActive
    : buttonStyle.fontColorInactive;

  const borderColor = isActive
    ? buttonStyle.borderColorActive
    : buttonStyle.borderColorInactive;

  return (
    <StyledButton
      height={"$9"}
      borderWidth={1}
      variant={buttonStyle.variant as "solid" | "outline" | "link" | undefined}
      borderRadius={buttonStyle.borderRadius}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      {...buttonProps}
    >
      {text ? (
        <Text color={fontColor} size="sm" fontWeight={600}>
          {text}
        </Text>
      ) : null}
    </StyledButton>
  );
};
